export default "/fonts/nexa-bold.c2b99812f7617bd31a220050147e457d.otf";